import React from 'react';
import DefaultModal, { DefaultModalProps } from './DefaultModal';

const ErrorModal = ({ title, ...rest }: DefaultModalProps) => {
  const icon = <i className="icon-error" />;
  const titleWithIcon = (
    <span>
      {icon}
      {title}
    </span>
  );
  return <DefaultModal title={titleWithIcon} {...rest} />;
};

export default ErrorModal;
